import { FC, useEffect } from 'react'
import { FutureInputDecoration } from 'components/features/future/FutureInputDecoration/FutureInputDecoration'
import { FutureRepeatInput, FutureRepeatInputProps } from 'components/features/future/FutureRepeatInput/FutureRepeatInput'
import { maskNumberPositiveTo1200 } from 'components/atoms/inputs/maskedInput'
import { useFormContext } from 'react-hook-form'
import { WithRecurrence } from 'components/features/future/types'
import { FutureFieldButtons } from 'components/features/future/FutureField/FutureFieldButtons'
import styles from 'components/features/future/FutureOccurrenceField/FutureOccurrenceField.styl'
import cn from 'classnames'

type FutureOccurrenceFieldProps =
  & Pick<FutureRepeatInputProps, 'options'>
  & {
    errors: Partial<Record<keyof WithRecurrence, string>>
  }
export const FutureOccurrenceField: FC<FutureOccurrenceFieldProps> = (props) => {
  const { errors, options } = props
  const { register, setValue, getValues, watch } = useFormContext<WithRecurrence>()

  const recurrence = watch('recurrence')

  useEffect(() => {
    if (recurrence === 'one_time') {
      setValue('recurrence_count', 1)
    }
  }, [getValues, recurrence, setValue])

  return (
    <>
      <FutureInputDecoration label='Occurrence' error={ errors.recurrence }>
        <FutureRepeatInput name='recurrence' register={ register } options={ options } />
      </FutureInputDecoration>

      <div className={ cn(styles.recurrenceCount, recurrence && recurrence !== 'one_time' && styles.visible) }>
        <FutureFieldButtons
          label='Number of occurrences'
          name='recurrence_count'
          mask={ maskNumberPositiveTo1200 }

          error={ errors.recurrence_count }

          min={ 1 }
          max={ 50 }
          step={ 1 }
        />
      </div>
    </>
  )
}
